import { createSlice } from "@reduxjs/toolkit";
import { fetchMapTeacherTrainedStatsData } from "../thunks/dashboardThunk"; 

const dashboarTeacherTrainedMapStateInt = createSlice({
  name: "MapTeacherTrainedStatsInt",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

 
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchMapTeacherTrainedStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMapTeacherTrainedStatsData.fulfilled, (state, action) => {
        state.data = action.payload.data===""?[]:action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMapTeacherTrainedStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboarTeacherTrainedMapStateInt.reducer;